import React from 'react'
/* styles */
import useStyles from './useStyles'
/* components */
import { Box } from '@mui/material'
import MoreItem from './MoreItem/MoreItem'
import MenuItem from '../MenuItem/MenuItem'
import { items } from '../userRoleMenuLinks/userRoleMenuLinks'
import { NavLink } from 'react-router-dom'

function MenuListMobile () {
  const classes = useStyles()

  return (
    <Box className={classes.container}>
      {items?.map((item, index) => (
        <NavLink key={index} to={item.link} style={{ textDecoration: 'none' }}>
          <Box className={classes[item.class]}>
            <MenuItem
              icon={item.icon}
              label={item.name}
              className={classes.icon}
            ></MenuItem>
          </Box>
        </NavLink>
      ))}

      <Box className={classes.more}>
        <MoreItem />
      </Box>
    </Box>
  )
}
export default MenuListMobile
